import { apiClient, ApiClient } from "@/lib/api/api-client";

export class SseService {
  private BASE_PATH =
    process.env.API_SSE_ENDPOINT || "http://localhost:8003/realtime";
  private apiVersion = "v1";
  private apiClient: ApiClient = apiClient;
  private token?: string | null;
  constructor() {
    this.assignToken();
  }

  assignToken = async () => {
    this.token = await this.apiClient.getToken();
  };

  getToken = () => {
    return this.token;
  };
  getSseEndpoint = (businessId: string) => {
    const topic = `business_${businessId}`;
    return `${this.BASE_PATH}/${this.apiVersion}/events?topics=${topic}`;
  };
}

export const sseService = new SseService();
